let load = require('./helpers/browser/esm-js-loader-shards-super.js')(4);
module.exports = (load("5gD5s")).then(() => parcelRequire('6dwdy'));